import { ref } from 'vue';

/* DepartmentUserSelector */
const expandedDepts = ref([]); // 펼쳐진 부서 ID 목록
const selectedDept = ref(null); // 선택된 부서
const deptList = ref([]); // 전체 부서 목록
const users = ref([]); // 현재 부서의 사용자 목록
const selectedUsers = ref([]); // 선택된 사용자 ID 목록
const selectedUserObject = ref(null); // 선택된 사용자 객체 (단일)

/* OrganizationUserSelector */
const expandedOrgs = ref([]); // 펼쳐진 조직 ID 목록
const selectedOrgId = ref(''); // 선택된 조직 ID
const employeeName = ref(''); // 검색어 입력 상태
const orgEmployeesData = ref([]); // 조직별 사용자 리스트 전체
const selectedFromDept = ref(new Set()); // 소속 직원 선택 상태
const selectedFromSelected = ref(new Set()); // 선택된 직원 선택 상태
const isSearch = ref(false);

/** 사용자 목록에 아이디 함께 표시 여부 */
const showUserId = ref(false);

const showUserSelectModal = ref(false); // 사용자 선택 팝업 표시 여부

export const useUserSelectorStore = () => {
  return {
    expandedDepts,
    selectedDept,
    deptList,
    users,
    selectedUsers,
    selectedUserObject,
    expandedOrgs,
    selectedOrgId,
    employeeName,
    orgEmployeesData,
    selectedFromDept,
    selectedFromSelected,
    isSearch,
    showUserId,
    showUserSelectModal
  };
};
